import React, { useContext, useState, useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import { Button, Tooltip } from '@mui/material';
import ProjectContext from '../contexts/ProjectContext';
import ProjectSelectDialog from './dialog/ProjectSelectDialog';


export default function TitleBlock(props) {
    const { isOffscreen, projects, setSelectedProject } = props
    const { isAuthenticated } = useAuth0();
    const projectContext = useContext(ProjectContext);
    const [dialogOpen, setDialogOpen] = useState(false);
    // const [projects, setProjects] = useState([])
    // const [selectedProject, setSelectedProject] = useState({"production_name": "", "image": ""})

    const handleOpenDialog = () => {
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    // Function not used
    //   If put into use, be sure to match behaviour of other function calls - use fetchWithAuth and get rid of the unnecessary accessToken
    const handleSelectProject = (project) => {
        var dbHeaders = new Headers()
        // dbHeaders.append('Authorization', `Bearer ${accessToken}`)
        dbHeaders.append('Content-Type', 'application/json')
        dbHeaders.append('X-Project-ID', projectContext?.project_db)
        const raw = JSON.stringify({
            'database': project.production_database
        })
        const requestDBOptions = {
            method: 'POST',
            headers: dbHeaders,
            body: raw,
            redirect: 'follow'
        }
        // fetch(`${process.env.REACT_APP_BACKEND_URL}/konsol/databases/`, requestDBOptions)
        setDialogOpen(false)
        window.location.reload()
    };



    return (
        <React.Fragment>
            <ProjectSelectDialog
                open={dialogOpen}
                onClose={handleCloseDialog}
                projects={projects}
                setSelectedProject={setSelectedProject}/>
            <Tooltip title={projectContext?.project_name ?? ''} arrow>
                <Button 
                    onClick={handleOpenDialog}>
                    <Box 
                        className={isOffscreen ? 'on' : ''}
                        display="flex" 
                        flex-direction="row"
                        justifyContent="center"
                        paddingTop="15px"
                        paddingBottom="40px">
                            <Avatar
                                id="sidebar-title-block"
                                alt="Konsol"
                                src="/logo/konsol-k-icon.svg" 
                                sx={{ 
                                    width: '110px', 
                                    height: '110px',
                                    opacity: '1',
                                    transform: 'translateX(0%)',
                                    transitionProperty: 'opacity, transform',
                                    transitionDuration: isOffscreen ? '0.2s' : '0.9s', 
                                    transitionTimingFunction: 'ease-out',
                                    '&.on': {
                                        opacity: '0',
                                        transform: 'translateX(-100%)'
                                    },
                                }}
                                className={isOffscreen ? 'on' : ''}/>
                            {
                                projectContext.project_image &&
                                <Avatar
                                    alt="Production Image"
                                    src={projectContext.project_image}
                                    sx={{
                                    position: 'absolute',
                                    width: 110,
                                    height: 110,
                                    backgroundColor: 'transparent',
                                    zIndex: -1, 
                                    opacity: '0.7',
                                    transform: 'translateX(0%)',
                                    transitionProperty: 'opacity, transform',
                                    transitionDuration: isOffscreen ? '0.2s' : '0.9s', 
                                    transitionTimingFunction: 'ease-out',
                                    '&.on': {
                                        opacity: '0',
                                        transform: 'translateX(-100%)'
                                    },
                                    }}
                                    className={isOffscreen ? 'on' : ''}/>
                            }
                    </Box>
                </Button>
            </Tooltip>
        </React.Fragment>
    );
}
